import { Link } from "react-router-dom";
import { BOOKS } from "@/lib/catalog";

export default function About() {
  return (
    <div className="pt-28 max-w-4xl mx-auto px-6 sm:px-8 pb-24">
      <span className="font-mono-ui text-xs uppercase tracking-[0.3em] text-primary-gold">
        About the Author
      </span>
      <h1 className="font-serif-display text-5xl sm:text-6xl font-semibold tracking-tight mt-6">
        Michael Leckie
      </h1>

      <div className="mt-10 space-y-6 text-soft text-lg leading-relaxed">
        <p>
          Michael Leckie is an Australian author, entrepreneur, and former Australian Army officer
          who hails from Adelaide, South Australia. Over a distinguished 30-year military career he
          rose through the enlisted ranks to become a Commissioned Officer.
        </p>
        <p>
          After leaving the military he channelled his life experience into storytelling — beginning
          with creative correspondence with his partner Angelique that evolved into published
          novels. Inspired by his lifelong love of Elvis Presley,{" "}
          <span className="text-text-primary italic">
            Suspicious Times: Elvis and the Time Travellers
          </span>{" "}
          is his most ambitious work — four interconnected novels under one cover.
        </p>
        <p>
          With further novels in draft, Michael Leckie is a storyteller with no shortage of stories
          left to tell.
        </p>
      </div>

      <div className="mt-16 border-t border-white/10 pt-12">
        <h2 className="font-serif-display text-3xl mb-8">The works</h2>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
          {BOOKS.map((b) => (
            <Link
              key={b.id}
              to={`/books/${b.id}`}
              data-testid={`about-book-${b.id}`}
              className="card-hover block border border-white/10 bg-[#121212]"
            >
              <img src={b.cover} alt={b.title} className="w-full aspect-[2/3] object-cover" />
              <p className="font-serif-display text-base p-3 leading-tight">{b.title}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
